import { useContext } from 'react';

import {
  type PanelsContextProps,
  PanelsContext,
} from '../contexts/PanelsContext.js';

/**
 * Internal hook wrapper for accessing the PanelsContext.
 * @internal
 */
export const usePanelsContext = (): PanelsContextProps => {
  return useContext(PanelsContext);
};
